import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-word-change-without-save-dialog',
  templateUrl: './confirm-word-change-without-save-dialog.component.html',
  styleUrls: ['./confirm-word-change-without-save-dialog.component.scss'],
})
export class ConfirmWordChangeWithoutSaveDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmWordChangeWithoutSaveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
